// extracted by css-extract-rspack-plugin
export default {"Label":"IssueTemplateBanner-module__Label__sunKGhB","Banner":"IssueTemplateBanner-module__Banner__rnKxKcX"};